class ROICalcExtended {
    constructor() {
        this.providerPrice = null;
        this.providerPricePlus = null;
        this.sendifyPrice = null;
        this.sendifyPricePlus = null;
        this.saved = null;
        this.savedPlus = null;
        this.priceTable = null;
        this.curWeight = '';
        this.curWeightPallet = '';
        this.average = null;
    }

    init(weight, weightPallet, week, weekPallet, where, average, averagePallet, form, submit, results, providerPrice, providerPricePlus, sendifyPrice, sendifyPricePlus, save, savePlus, priceTable) {
        this.weightBlock = weight;
        this.weightBlockPallet = weightPallet;
        this.week = week;
        this.weekPallet = weekPallet;
        this.where = where;
        this.average = average;
        this.averagePallet = averagePallet;
        this.form = form;
        this.submit = submit;
        this.resultsBlock = results;
        this.providerPriceBlock = providerPrice;
        this.providerPricePlusBlock = providerPricePlus;
        this.sendifyPriceBlock = sendifyPrice;
        this.sendifyPlusPriceBlock = sendifyPricePlus;
        this.saveBlock = save;
        this.saveBlockPlus = savePlus;
        this.priceTable = priceTable;
        this.average.setAttribute('max', this.priceTable[this.where.value].service_type[0].price_table.length - 1);
        this.averagePallet.setAttribute('max', this.priceTable[this.where.value].service_type[1].price_table.length - 1);
    }

    get getCurrentWeight() {
        return this.priceTable[this.getWhere].service_type[0].price_table[this.getAverage].weight ? this.priceTable[this.getWhere].service_type[0].price_table[this.getAverage].weight : ''
    }

    get getCurrentWeightPallet() {
        return this.priceTable[this.getWhere].service_type[1].price_table[this.getAveragePallet].weight ? this.priceTable[this.getWhere].service_type[1].price_table[this.getAveragePallet].weight : ''
    }

    get getWeek() {
        return this.week.value ? parseInt(this.week.value) : null
    }

    get getWeekPallet() {
        return this.weekPallet.value ? parseInt(this.weekPallet.value) : null
    }

    get getWhere() {
        return /^-?\d+$/.test(this.where.value) ? this.where.value : null
    }

    get getAverage() {
        return this.average.value ? parseInt(this.average.value) : null
    }

    get getAveragePallet() {
        return this.averagePallet.value ? parseInt(this.averagePallet.value) : null
    }

    get getProviderPrice() {
        const providerPriceParcel = (this.getWeek * this.priceTable[this.getWhere].service_type[0].price_table[this.getAverage].market_price);
        const providerPricePallet = (this.getWeekPallet * this.priceTable[this.getWhere].service_type[1].price_table[this.getAveragePallet].market_price);
        return +((providerPriceParcel + providerPricePallet) * 12).toFixed();
    }

    get getProviderPlusPrice() {
        const providerPlusPriceParcel = (this.getWeek * this.priceTable[this.getWhere].service_type[0].price_table[this.getAverage].market_price);
        const providerPlusPricePallet = (this.getWeekPallet * this.priceTable[this.getWhere].service_type[1].price_table[this.getAveragePallet].market_price);
        return +((providerPlusPriceParcel + providerPlusPricePallet) * 12).toFixed();
    }

    get getSendifyPrice() {
        const sendifyFreePriceParcel = ((this.getWeek * this.priceTable[this.getWhere].service_type[0].price_table[this.getAverage].sendify_free));
        const sendifyFreePricePallet = ((this.getWeekPallet * this.priceTable[this.getWhere].service_type[1].price_table[this.getAveragePallet].sendify_free));
        return +((sendifyFreePriceParcel + sendifyFreePricePallet) * 12).toFixed();
    }

    get getSendifyPlusPrice() {
        const sendifyPlusPriceParcel = (this.getWeek * this.priceTable[this.getWhere].service_type[0].price_table[this.getAverage].sendify_plus);
        const sendifyPlusPricePallet = (this.getWeekPallet * this.priceTable[this.getWhere].service_type[1].price_table[this.getAveragePallet].sendify_plus);
        return +((sendifyPlusPriceParcel + sendifyPlusPricePallet) * 12).toFixed();
    }

    get getSaved() {
        if (!this.providerPrice || !this.sendifyPrice || !this.sendifyPricePlus) return null;
        return +(this.providerPrice - this.sendifyPrice).toFixed();
    }

    get getSavedPlus() {
        if (!this.providerPrice || !this.sendifyPrice || !this.sendifyPricePlus) return null;
        return +(this.providerPrice - this.sendifyPricePlus).toFixed();
    }

    set setProviderPrice(price) {
        this.providerPrice = price;
    }

    set setProviderPlusPrice(price) {
        this.providerPricePlus = price;
    }

    set setSendifyPrice(price) {
        this.sendifyPrice = price;
    }

    set setSendifyPricePlus(price) {
        this.sendifyPricePlus = price;
    }

    set setSaved(price) {
        this.saved = price;
    }

    set setSavedPlus(price) {
        this.savedPlus = price;
    }

    set setCurrentWeight(weight) {
        this.curWeight = this.priceTable[this.getWhere].service_type[0].price_table[this.getAverage].weight ? this.priceTable[this.getWhere].service_type[0].price_table[this.getAverage].weight : '';
    }

    set setCurrentWeightPallet(weightPallet) {
        this.curWeightPallet = this.priceTable[this.getWhere].service_type[1].price_table[this.getAveragePallet].weight ? this.priceTable[this.getWhere].service_type[1].price_table[this.getAveragePallet].weight : '';
    }

    set setAverage(priceTable) {
        this.average.setAttribute('max', this.priceTable[this.where.value].service_type[0].price_table.length - 1);
    }

    set setAveragePallet(priceTable) {
        this.averagePallet.setAttribute('max', this.priceTable[this.where.value].service_type[1].price_table.length - 1);
    }

    clearResults() {
        if (this.sendifyPrice && this.providerPrice && this.sendifyPricePlus) {
            this.setProviderPrice = null;
            this.setSendifyPrice = null;
            this.setSendifyPricePlus = null;
            this.setSaved = null;
            this.setSavedPlus = null;
            this.hide(this.resultsBlock);
            this.submit.removeAttribute('disabled');
        }
    }

    hide(element) {
        element.style.display = 'none';
    }

    show(element) {
        element.style.display = 'block';
    }

    setOutput(element, value) {
        if (!element || !value) return;
        element.innerHTML = value;
    }

    setValue(element, value) {
        if (!element || !value) return;
        element.value = value;
    }
}

export default ROICalcExtended;



// WEBPACK FOOTER //
// ./scripts/modules/roiCalcExtended.js